import { CURRENT_ORGANIZATION_STORAGE_KEY } from '@plug/config/consts';
import cookie from 'js-cookie';

export default () => {
  return cookie.get(CURRENT_ORGANIZATION_STORAGE_KEY)
    ? JSON.parse(decodeURIComponent(cookie.get(CURRENT_ORGANIZATION_STORAGE_KEY) || ''))
    : undefined;
};
